module.exports = __webpack_public_path__ + "img/reward-diamond.611b010d.webp";